/**
 * A duration a person can read at a glance.
 *
 * Deliberately coarse above a minute: a conversion runs 10-55 minutes and the
 * estimate carries roughly 10% error, so "23 min" is as much precision as the
 * number actually has. Showing "23 min 14 sec" would claim accuracy it does
 * not have.
 */
export function humanDuration(seconds: number): string {
	if (seconds < 60) return `${Math.max(0, Math.round(seconds))} sec`;
	const minutes = Math.round(seconds / 60);
	if (minutes < 60) return `${minutes} min`;
	const remainder = minutes % 60;
	return remainder ? `${Math.floor(minutes / 60)} hr ${remainder} min` : `${Math.floor(minutes / 60)} hr`;
}
